__turbopack_context__.v({
  "productInfo": "index-module__XCxvPG__productInfo",
  "textBox": "index-module__XCxvPG__textBox",
});
